export default "__VITE_ASSET__OWrFGurz__"